<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="item.id ? 'Update' : 'Create'"
  >
    <template slot="header">
      <span>{{ item.id ? 'Update' : 'Create' }} Installation Material Item</span>
    </template>
    <template slot="body">
      <v-row>
        <v-col
          cols="8"
          class="pb-0"
        >
          <v-text-field
            v-model="item.name"
            :rules="[(v) => !!v && v.trim().length > 0 || 'Name is required']"
          >
            <template slot="label">
              Name<RedAsterisk />
            </template>
          </v-text-field>
        </v-col>
        <v-col
          cols="4"
          class="pb-0"
        >
          <v-text-field
            v-model="item.weight"
            type="number"
            min="0"
            suffix="kg"
          >
            <template slot="label">
              Weight
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </template>
  </the-dialog-box>
</template>

<script>

export default {
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      name: '',
      weight: null,
    },
  }),
  created() {
    this.item = { ...this.itemDto };
  },
  methods: {

    async get(id) {
      if (!id) return;
      const submitModel = {
        filters: {
          id,
        },
      };
      const res = await this.$api.billOfLadingExtraItemType.read(submitModel);
      if (!res || res.data < 1 || !res.data[0]) {
        this.$bus.$emit('showError', 'Unable to retrieve this item');
        return;
      }
      const firstIndex = 0;
      this.item = res.data[firstIndex];
    },

    async submit() {
      if (!this.item) return false;
      if (this.item.weight < 0) {
        this.$bus.$emit('showError', 'Weight cannot be negative');
        return false;
      }
      this.item.name = this.item.name.trim();
      if (!this.item.name) {
        this.$bus.$emit('showError', 'Name is required');
        return false;
      }
      let res;
      if (this.item.id) {
        res = await this.$api.billOfLadingExtraItemType.update(this.item);
      } else {
        res = await this.$api.billOfLadingExtraItemType.store(this.item);
      }

      if (!res) {
        this.$bus.$emit('showError');
        return false;
      }

      this.$emit('success');
      return res;
    },

    open(id) {
      if (id) {
        this.item.id = id;
        this.get(id);
      } else {
        this.item = { ...this.itemDto };
      }
      this.$refs.dialogBox.open();
    },
  },
};
</script>
